import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestBannerLinksOrderPut = {
    path: "/banner-links/order",
    method: RouteHttpVerb.PUT
};
export { locationRestBannerLinksOrderPut };
